// campaign.actions.ts
import {createAction, props} from '@ngrx/store';
import {Campaign} from 'gamesis-story-client';

export const loadCampaigns = createAction('[Campaign] Load Campaigns');
export const loadCampaignsSuccess = createAction('[Campaign] Load Campaigns Success', props<{ campaigns: Campaign[] }>());
export const campaignsFailure = createAction('[Campaign] Campaigns Failure', props<{ error: any }>());
export const setCampaign = createAction('[Campaign] Select Campaign', props<{ id: string }>());
export const exitCampaign = createAction('[Campaign] Exit Campaign');
export const createCampaign = createAction('[Campaign] Create Campaign', props<{ campaign: string }>());
export const createCampaignSuccess = createAction('[Campaign] Create Campaign Success', props<{ id: string }>());
export const deleteCampaign = createAction('[Campaign] Delete Campaign');
export const deleteCampaignSuccess = createAction('[Campaign] Delete Campaign Success');
